import React from "react";

function About() {
  return (
    <div className=" relative h-[50dvw]  flex justify-center items-center flex-col">
      {/* <div className="flex flex-auto items-center gap-10 justify-between">
        <div className="flex flex-1 flex-col gap-2">
          <h1 className=" text-5xl font-semibold text-white/90"> About Us.</h1>
          <p className="text-white/50 text-xl">
            We’re impartial and independent, and every day we create
            distinctive, world-className programmes and content which inform,
            educate and entertain millions of people in the around the world.
          </p>
        </div>
        <div className="flex-1 items-center justify-center flex gap-2">
          <img src={aboutImageOne} alt="" className="h-[21pc] rounded-xl" />
        </div>
      </div>
      <div className="flex flex-auto items-center gap-10 justify-between">
        <div className="flex-1 items-center justify-center flex gap-2">
          <img src={aboutImageFour} alt="" className="h-[21pc] rounded-xl" />
        </div>{" "}
        <div className="flex flex-1 flex-col gap-2">
          <h1 className=" text-5xl font-semibold text-white/90"> Founder</h1>
          <p className="text-white/50 text-xl">
            We’re impartial and independent, and every day we create
            distinctive, world-className programmes and content
          </p>
        </div>
      </div>{" "}
      <img
        src="https://opne9reactnext.vercel.app/_next/static/media/bg-home2.d35f9112.png"
        className="left-0 top-[15pc] absolute"
        alt=""
      /> */}
    </div>
  );
}

export default About;
